
function DbSynch() {
    /// <summary>
    /// This object provides js functions for the Widget.Admin.DbSynch.js. <br/>
    /// <br/>
    /// Author: ARF<br />
    /// Date: 31.5.2017<br />
    /// Copyright ©: EUDT GmbH 2017 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 29.6.2017                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>

}

DbSynch.prototype = new vcTemplate();
DbSynch.prototype.syncType = -1;
DbSynch.prototype.init = function () {
    /// <summary>
    /// This function inits the menu click handler. 
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }
        me.showInfo("", "", false);

        //init the full-ext search
        me.visual.find("#div-filter").vcFilter({ callback: function () { me.filter(); } });
        me.visual.find("#chb-selection").off("click").on("click", function () { me.selectAll( $(this)); });
        me.visual.find(".vc-list-table").height(me.height - 130);
        me.visual.find("#div-btn-apply").off("click").on("click", function () { me.apply(true); }).button();
        me.visual.find("#div-btn-ignore").off("click").on("click", function () { me.apply(false); }).button();

        me.visual.find("#div-btn-sync-data").off("click").on("click", function () {
            me.syncType = 1;
            me.pwdDialog.dialog("open");
        }).button();
        me.visual.find("#div-btn-sync-media").off("click").on("click", function () {
            me.syncType = 2;
            me.pwdDialog.dialog("open");

        }).button();


        me.visual.find(".vc-list-item").off("click").on("click", function () {me.select($(this)); });

        me.initPwdPopup();

        me.filter();
    return true;
    } catch (ex) { me.writeError('init', ex); return false }

}



DbSynch.prototype.filter = function () {
    /// <summary>
    /// This function filters the entries based on a given filter and filters the complete content of the list based on the vcFilter  <br/>
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }

        //hide all
        me.visual.find(".vc-list-table .vc-list-item").removeClass("found").data("counter", 0).hide();

        //we add the 'found' class to all items we want to filter based on the vcfilter tags
        me.setTagFilter(".vc-filter", ".vc-list-table .vc-list-item", "found");

        me.visual.find(".vc-list-table .vc-list-item.found").show();
        me.visual.find(".vc-list-table .vc-list-item").removeClass("alt");
        me.visual.find(".vc-list-table .vc-list-item.found:even").addClass("alt");

     
        return true;
    } catch (ex) {
        me.writeError('filter', ex);
        return false;
    }

};


DbSynch.prototype.select = function (obj) {
    /// <summary>
    /// This function handles the select/unselect functionality <br/>
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }
       
        if (obj.find("input").is(":checked")) {
            obj.removeClass("selected");
            obj.find("input").prop("checked", false);
            return true;
        } else {

            obj.addClass("selected");
            obj.find("input").prop("checked", true);
            return true;
        }

        return true;
    } catch (ex) { me.writeError('selectAll', ex); return false; }
};

DbSynch.prototype.selectAll = function (obj) {
    /// <summary>
    /// This function handles the select/unselect functionality <br/>
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }

        if (obj.is(":checked")) {
            me.visual.find(".vc-list-item.found").addClass("selected");
             me.visual.find(".vc-list-table .vc-list-item").filter(function () { return $(this).find(".col6").html().length > 0; }).removeClass("selected");
           me.visual.find(".vc-list-item.selected input").prop("checked", true); 
        } else {
            me.visual.find(".vc-list-table li").removeClass("selected");
             me.visual.find(".vc-list-table input").prop("checked", false); 
        }

        return true;
    } catch (ex) { me.writeError('selectAll', ex); return false; }
};

DbSynch.prototype.initPwdPopup = function () {
    /// <summary>
    /// This function inits the edit dialog for later use. 
    /// </summary>
    var me = this;
    var h, w;
    try {
        me.pwdDialog = null;
        me.myDiv = $("<div>").attr("id", "div-dialog").css("z-index", 10000);
        if (typeof (myClass) !== "undefined") {
            me.myDiv.addClass(myClass);
        }
        var txtPwd = $("<input>").attr("type", "password").attr("id", "txt-pwd").css("padding", "5px");
        me.myDiv.append("<b>Insert your password:</b><br/>");
        me.myDiv.append(txtPwd);

        var w = 200;
        var h = 130;

        var options = {
            autoOpen: false,
            width: w,
            height: h,
            modal: true,
            dialogClass: "modal-popup-dialog",   // "modal-popup-dialog"

        };

            options.buttons = [{
                text: "Send password", click: function () {
                    me.pwdDialog.dialog('close');
                    me.sync(me.syncType, txtPwd.val());
                    return true;
                }
            }];
      

        me.pwdDialog = me.myDiv.dialog(options);

        me.pwdDialog.width = w;
        me.pwdDialog.height = h;

        return true;
    } catch (ex) {
        me.writeError('initPwdPopup', ex);
        return false;
    }
}




DbSynch.prototype.sync = function (type, pwd) {
    /// <summary>
    ///  This function generates a list of selected ids and sends them to the server for applying. 
    /// </summary>
    var me = this;
    var lst = [];
    try {
        if (me.error) {
            return false;
        }
        me.visual.find(".vc-list").html("please wait ...");
        window.VisualCoreService.getData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, '', '', 1, 2, JSON.stringify({ 'Type': type, Pwd: pwd }),
            function (result) {
               
                if (result.length > 0) {
                    me.showInfo("ERROR - " + result, "", true);
                } else {
                    alert("Sync done - page gets reloaded!");
                     location.reload();
                   
                }

                return true;
            });

        return true;
    } catch (ex) { me.writeError('sync', ex); return false }

}



DbSynch.prototype.apply = function (bExecuteSQL) {
    /// <summary>
    ///  This function generates a list of selected ids and sends them to the server for applying. 
    /// </summary>
    var me = this;
    var lst = [];
    try {
        if (me.error) {
            return false;
        }

        me.visual.find(".vc-list-item.found .chb:checked").each(function() {
            if (parseInt($(this).data("id"), 10) > 0) {
                lst.push($(this).data("id"));
            }
        });
        if (lst.length === 0) {return true}
      
        window.VisualCoreService.updateData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, '', '', 1, 2, JSON.stringify({ 'List':lst, 'Execute':bExecuteSQL }),
       function (result) {
          
           if (result === null) { me.showMessage(me.resources.err_saveData, true); return false; }
           if (result.length === 0) {
               me.visual.find(".vc-list-item.found .chb:checked").each(function () {
                   $(this).parents("li").find(".col0").html("<br/>");
                   $(this).parents("li").find(".col6").html("ok!");

               });
               me.visual.find("#div-warning").html("").hide();
               me.filter();
           } else {
               //me.showMessage(me.resources.err_saveData, true);
               me.visual.find("#div-warning").html(result).show();
               return false;
           }

           return true;
       });

        return true;
    } catch (ex) { me.writeError('apply', ex); return false }

}


DbSynch.prototype.specificInfoHandling = function (bError) {
    /// <summary>
    /// This function  hides/fades out content on error state. 
    /// </summary>
    var me = this;
    try {
        if (bError) {
           me.visual.find("#div-menu, .vc-list-table").hide();
        }
        return true;
    } catch (ex) { me.writeError('specificInfoHandling', ex); return false }
};


